module.exports = __webpack_public_path__ + "img/品質管理4-8.cb6c5bf5.png";